import store from '../containers/App/store';
import { authFail } from '../redux/actions/authActions';
import * as httpCodes from 'http-status-codes';

const handleServiceResponse = async (handler) => {
    try {
        return await handler();
    } catch (error) {
        console.log(error);
        if(error.response) {
            const { status, data } = error.response;
            if(status === httpCodes.UNAUTHORIZED) {
                localStorage.setItem('loggedout', true);
                store.dispatch(authFail());
            } else {
                console.log(status, data);
            }
        }
       
        throw error;
    }
}

export { handleServiceResponse };
export default handleServiceResponse;